"use client";

import { FeatureHighlight } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import { floorPlanDetail } from "../../../../public/images/logos";

const FeatureDescriptions = () => {
  const tH = useTranslations("home");

  return (
    // mt-[-350px]
    <div className="gs--page-column w-full">
      <div className="flex flex-col gap-20">
        {/* Feature Informations */}
        <FeatureHighlight
          src={floorPlanDetail}
          alt={"floor plan logo"}
          title={tH("feature.title")}
          text={tH("feature.text")}
          list={[
            tH("feature.listItem"),
            tH("feature.listItem2"),
            tH("feature.listItem3"),
            tH("feature.listItem4"),
          ]}
          link
          linkTitle={tH("feature.linkTitle")}
          href="/grundriss-designs"
        />
        <FeatureHighlight
          src={floorPlanDetail}
          alt={"floor plan logo"}
          title={tH("feature2.title")}
          text={tH("feature2.text")}
          list={[
            tH("feature2.listItem"),
            tH("feature2.listItem2"),
            tH("feature2.listItem3"),
            tH("feature2.listItem4"),
          ]}
        />
      </div>
    </div>
  );
};

export default FeatureDescriptions;
